import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import pubgTooltip from '@shared/assets/images/cyber/PubgTooltip.jpg';
export const PubgTooltip = () => <WrapperTooltip>
    <Heading>Как&nbsp;найти свой UID в&nbsp;PUBG Mobile?</Heading>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <WrapperList>
      <List data={[{
      id: 1,
      text: 'Откройте приложение PUBG Mobile. Нажмите на\u00A0свой аватар в\u00A0левом верхнем углу главного экрана.'
    }, {
      id: 2,
      text: 'В\u00A0профиле вы увидите UID над аватаркой профиля'
    }]} size="md" sizemob="md" />
    </WrapperList>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <ImageWrapper>
      <Image src={pubgTooltip} width={536} height={140} alt="genshin" style={{
      borderRadius: '16px'
    }} />
    </ImageWrapper>
  </WrapperTooltip>;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const WrapperTooltip = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperTooltip",
  class: "wwscpp4",
  propsAsIs: false,
  vars: {
    "wwscpp4-0": [_exp()],
    "wwscpp4-1": [_exp2()],
    "wwscpp4-2": [_exp3(), "px"],
    "wwscpp4-3": [_exp4()],
    "wwscpp4-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "w1htg220",
  propsAsIs: false,
  vars: {
    "w1htg220-0": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h1r1jrfx",
  propsAsIs: false,
  vars: {
    "h1r1jrfx-0": [_exp7()],
    "h1r1jrfx-1": [_exp8(), "px"],
    "h1r1jrfx-2": [_exp9()],
    "h1r1jrfx-3": [_exp0(), "px"],
    "h1r1jrfx-4": [_exp1()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ih0xb5w",
  propsAsIs: false
});

require("./PubgTooltip.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PubgTooltip.tsx");